const SECTION_LENGTH = 4;
const SECTION_DIVIDER = '–';

export const formatCode = (code: string): string => {
    const firstGroupLength = code.length % SECTION_LENGTH;

    const firstGroup = firstGroupLength !== 0 ? code.substr(0, firstGroupLength) + SECTION_DIVIDER : '';
    const restStr = code.substr(firstGroupLength);

    let formattedRestStr = '';

    for (let i = 0, length = restStr.length; i < length; i += 1) {
        const currentChar = restStr[i];

        const shouldInsertDivider = (i + 1) % SECTION_LENGTH === 0 && i !== length - 1;

        formattedRestStr += shouldInsertDivider ? currentChar + SECTION_DIVIDER : currentChar;
    }

    return firstGroup + formattedRestStr;
};
